import AccountSettingsForm from 'components/account-settings';
import React from 'react';
import { createStyles } from './styles';

/**
 * IMPORTANT! This page is not currently used.
 */
const AccountSettingsPage = (): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={classes.appWrapper}>
      <div className={classes.formWrapper}>
        <h1 className={classes.title}>Account Settings</h1>
        <AccountSettingsForm />
      </div>
    </div>
  );
};

export default AccountSettingsPage;
